export default "__VITE_ASSET__Zm0FVkxc__"